import { useEffect, useState } from "react";
import { api } from "../../api";
import { useConsoleTown } from "./ConsoleLayout";

export default function ConsoleWallet() {
  const { town, reloadTowns } = useConsoleTown();
  const [balance, setBalance] = useState(0);
  const [slowBudget, setSlowBudget] = useState(0);
  const [dailyCost, setDailyCost] = useState(0);
  const [status, setStatus] = useState("active");
  const [entries, setEntries] = useState<any[]>([]);
  const [amount, setAmount] = useState(1000);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const load = () => {
    api.consoleWallet(town.id)
      .then((result) => {
        setBalance(Number(result.balance || 0));
        setSlowBudget(Number(result.slowBudget || 0));
        setDailyCost(Number(result.dailyCost || 0));
        setStatus(String(result.status || "active"));
        setEntries(result.entries || []);
      })
      .catch((reason) => setError(reason.message || "钱包加载失败"));
  };
  useEffect(load, [town.id]);

  const recharge = async () => {
    if (!Number.isFinite(amount) || amount <= 0) return;
    setBusy(true);
    setError("");
    try {
      await api.consoleRecharge(town.id, amount);
      await reloadTowns();
      load();
    } catch (reason: any) {
      setError(reason.message || "充值失败");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-black">钱包与流水</h1>
      {error && <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>}
      <section className="grid gap-5 md:grid-cols-[minmax(0,1fr)_300px]">
        <div className="rounded-xl border border-[#ddd7c4] bg-white p-6 shadow-sm">
          <div className="text-sm text-[#77705f]">当前余额</div>
          <div className="mt-2 text-4xl font-black text-[#2f6e5b]">{balance.toLocaleString()}</div>
          <div className="mt-3 grid gap-2 text-xs text-[#77705f] sm:grid-cols-3">
            <div className="rounded-lg bg-[#f7f5ed] px-3 py-2"><span className="block">当前状态</span><strong className="mt-1 block text-[#3f3a32]">{status === "slow" ? "慢速中" : status === "sleeping" ? "沉睡中" : "活跃"}</strong></div>
            <div className="rounded-lg bg-[#f7f5ed] px-3 py-2"><span className="block">预估日耗</span><strong className="mt-1 block text-[#3f3a32]">{dailyCost.toLocaleString()} token</strong></div>
            <div className="rounded-lg bg-[#f7f5ed] px-3 py-2"><span className="block">慢速预算</span><strong className="mt-1 block text-[#3f3a32]">{slowBudget.toLocaleString()} token</strong></div>
          </div>
        </div>
        <div className="rounded-xl border border-[#ddd7c4] bg-white p-5 shadow-sm">
          <div className="font-bold">充值打桩</div>
          <div className="mt-3 flex gap-2">
            {[500, 1000, 5000].map((value) => (
              <button key={value} onClick={() => setAmount(value)} className={`flex-1 rounded-lg border px-2 py-2 text-xs font-bold ${amount === value ? "border-[#2f6e5b] bg-[#e0eee8]" : "border-[#d8d2bf]"}`}>{value}</button>
            ))}
          </div>
          <input type="number" min="1" value={amount} onChange={(event) => setAmount(Number(event.target.value))} className="mt-3 w-full rounded-lg border border-[#d8d2bf] px-3 py-2.5 outline-none focus:border-[#2f6e5b]" />
          <button disabled={busy || amount <= 0} onClick={recharge} className="mt-3 w-full rounded-lg bg-[#2f6e5b] py-2.5 text-sm font-bold text-white disabled:opacity-50">{busy ? "处理中..." : "模拟支付成功"}</button>
        </div>
      </section>

      <section className="overflow-hidden rounded-xl border border-[#ddd7c4] bg-white shadow-sm">
        <div className="border-b border-[#ebe6d6] px-5 py-3.5 font-bold">流水</div>
        <div className="overflow-x-auto">
          <table className="w-full min-w-[680px] text-left text-sm">
            <thead className="bg-[#faf8f2] text-xs text-[#77705f]"><tr><th className="px-4 py-3">时间</th><th>类型</th><th>变动</th><th>余额</th><th className="pr-4">备注</th></tr></thead>
            <tbody className="divide-y divide-[#f0ecdf]">
              {entries.map((entry) => (
                <tr key={entry.id}>
                  <td className="px-4 py-3 text-xs">{new Date(entry.createdAt).toLocaleString("zh-CN", { hour12: false })}</td>
                  <td className="py-3">{entry.kind}</td>
                  <td className={`py-3 font-bold ${Number(entry.delta) >= 0 ? "text-emerald-700" : "text-red-700"}`}>{Number(entry.delta) >= 0 ? "+" : ""}{Number(entry.delta).toLocaleString()}</td>
                  <td className="py-3">{Number(entry.balanceAfter).toLocaleString()}</td>
                  <td className="pr-4 py-3 text-[#665f4f]">{entry.memo || entry.refType || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!entries.length && <div className="py-14 text-center text-sm text-[#77705f]">暂无流水</div>}
      </section>
    </div>
  );
}
